<template>
  <div v-if="labelSet" class="mission-card-process" :class="`color-type-${mission.colorType}`">
    <p class="mission-card-process__title">{{ labelSet.title }}</p>
    <div class="mission-card-process__main">
      <template v-if="mission.achievementCountDispType === 'countUp'">
        <p class="mission-card-process__rest">
          <span>{{ labelSet.restPre }}</span>
          <span class="mission-card-process__rest-count">{{ mission.achievedMissionsCount }}</span>
          <span>{{ labelSet.restUnit }}</span>
        </p>
      </template>
      <template v-else>
        <p class="mission-card-process__rest">
          <span>{{ labelSet.restPre }}</span>
          <span class="mission-card-process__rest-count">{{
            mission.leftCountUntilNextAchievement
          }}</span>
          <span>{{ labelSet.restUnit }}</span>
        </p>
        <p class="mission-card-process__total" v-if="mission.achievedMissionsCount">
          <span>{{ labelSet.currentPre }}</span>
          <span class="mission-card-process__total-count">{{ mission.achievedMissionsCount }}</span>
          <span>{{ labelSet.currentUnit }}</span>
        </p>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import I18n from '@/locales/I18n'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'

/**
 * ミッション画面 ミッション達成状況 達成カウント表示パーツ
 */
export default defineComponent({
  name: 'MissionProcessParts',
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
  },
  setup(props) {
    const labelSet = computed(() => {
      switch (props.mission.achievementCountDispType) {
        case 'login':
          return {
            title: I18n.tc('MissionPage.process.login.title'),
            restPre: I18n.tc('MissionPage.process.login.restPre'),
            restUnit: I18n.tc('MissionPage.process.login.restUnit'),
            currentPre: I18n.tc('MissionPage.process.login.currentPre'),
            currentUnit: I18n.tc('MissionPage.process.login.currentUnit'),
          }
        case 'countUp':
          return {
            title: I18n.tc('MissionPage.process.countUp.title'),
            restPre: I18n.tc('MissionPage.process.countUp.restPre'),
            restUnit: I18n.tc('MissionPage.process.countUp.restUnit'),
            currentPre: I18n.tc('MissionPage.process.countUp.currentPre'),
            currentUnit: I18n.tc('MissionPage.process.countUp.currentUnit'),
          }
        case 'continuation':
          return {
            title: I18n.tc('MissionPage.process.continuation.title'),
            restPre: I18n.tc('MissionPage.process.continuation.restPre'),
            restUnit: I18n.tc('MissionPage.process.continuation.restUnit'),
            currentPre: I18n.tc('MissionPage.process.continuation.currentPre'),
            currentUnit: I18n.tc('MissionPage.process.continuation.currentUnit'),
          }
        case 'default':
          return {
            title: I18n.tc('MissionPage.process.default.title'),
            restPre: I18n.tc('MissionPage.process.default.restPre'),
            restUnit: I18n.tc('MissionPage.process.default.restUnit'),
            currentPre: I18n.tc('MissionPage.process.default.currentPre'),
            currentUnit: I18n.tc('MissionPage.process.default.currentUnit'),
          }
        default:
          return null
      }
    })
    return {
      labelSet,
    }
  },
})
</script>

<style scoped lang="scss">
.mission-card-process {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 34px;
  padding: 4px 9px;
  background-color: rgba($black, 0.15);
  border-radius: 4px;

  &.color-type-1 {
    color: #73ffdd;
  }

  &.color-type-2 {
    color: #e0ffa0;
  }

  &.color-type-3 {
    color: #f7c6ff;
  }

  &.color-type-4 {
    color: #ff5d5d;
  }

  &__main {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    max-width: 60%;
  }

  &__title {
    max-width: 40%;
    font-size: 11px;
    letter-spacing: 0.02em;
  }

  &__rest {
    display: flex;
    align-items: center;
    font-size: 11px;
    letter-spacing: 0.02em;
  }

  &__rest-count {
    margin-right: 2px;
    margin-left: 2px;
    font-size: 20px;
    font-weight: 500;
  }

  &__total {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 21px;
    font-size: 10px;
    letter-spacing: 0.02em;

    &::before {
      position: absolute;
      top: 50%;
      left: -13px;
      content: '/';
      font-size: 12px;
      transform: translateY(-55%);
    }
  }

  &__total-count {
    margin-right: 2px;
    margin-left: 2px;
    font-size: 13px;
    font-weight: 500;
  }

  @media screen and (max-width: $responsiveTabletWidth) {
  }
}
</style>
